var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageIcons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Image Icons") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Image-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,3 L4,3 C3.45,3 3,3.45 3,4 L3,16 C3,16.55 3.45,17 4,17 L16,17 C16.55,17 17,16.55 17,16 L17,4 C17,3.45 16.55,3 16,3 L16,3 Z M10,5.75 C11.24,5.75 12.25,6.76 12.25,8 C12.25,9.24 11.24,10.25 10,10.25 C8.76,10.25 7.75,9.24 7.75,8 C7.75,6.76 8.76,5.75 10,5.75 L10,5.75 Z M14.5,15 L5.5,15 L5.5,14.25 C5.5,12.75 8.5,12 10,12 C11.5,12 14.5,12.75 14.5,14.25 L14.5,15 L14.5,15 Z",
    id: "Shape",
    fill: "#505F79"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcons);
export default __webpack_public_path__ + "static/media/Image_Icons.e6e3534e331b8c2f1bca31fc31c70931.svg";
export { ForwardRef as ReactComponent };